import { keyBy } from 'lodash';
import { defaultFilter } from 'components/molecules/filters/utils';
import { ViewDefinitionTransformer } from 'components/molecules/views';
import {
  asColumnOrder,
  ColumnOrder,
  withValidColumnOrderProps,
} from 'components/organisms/grid-custom-column';
import { FilterableField } from 'components/organisms/tasks/fields';
import { FieldFilter } from 'components/organisms/tasks/filters';
import {
  from_filter,
  to_filter,
} from 'components/pages/api-filter-transformer';
import { fromGroup, toGroup } from './group-tranformer';
import {
  ApiProjectListViewDefinition,
  ProjectListViewDefinition,
} from './types';

export const getViewDefinitionTransformer = (
  lookupByFieldName: Record<string, FilterableField>,
  defaultColumnOrder: ColumnOrder[],
): ViewDefinitionTransformer<
  ApiProjectListViewDefinition,
  ProjectListViewDefinition
> => ({
  from: ({
    group,
    filter: viewDefinitionFilter,
    columnOrder,
  }: ApiProjectListViewDefinition): ProjectListViewDefinition => {
    return {
      filter: viewDefinitionFilter
        ? from_filter(lookupByFieldName)(viewDefinitionFilter)
        : defaultFilter,
      groupBy: fromGroup(keyBy(Object.values(lookupByFieldName), 'fieldId'))(
        group?.fields[0],
      ),
      columnOrder: columnOrder?.map(withValidColumnOrderProps),
    };
  },
  to: ({
    filter: viewDefinitionFilter,
    groupBy,
    columnOrder,
  }: ProjectListViewDefinition): ApiProjectListViewDefinition => {
    const groupField = lookupByFieldName[groupBy];
    const group = groupField && toGroup(groupField);
    const isFilterValid =
      viewDefinitionFilter.criteria.filter(FieldFilter.isValid).length > 0;

    return {
      filter: isFilterValid ? to_filter(viewDefinitionFilter) : undefined,
      group: group && { fields: [group] },
      columnOrder:
        JSON.stringify(defaultColumnOrder) === JSON.stringify(columnOrder)
          ? undefined
          : asColumnOrder(columnOrder),
    };
  },
});
